<template>
  <div class="view-about">
    <PageAboutHero />
    <b-container>
      <b-row>
        <b-col lg="8" offset-lg="3">
          <h2 class="pt-30 pt-md-40">
            Why we built The Hub
          </h2>
          <p class="fs18 lh18 pt-30" v-html="sections[0]"></p>
          <h2 class="pt-60 pt-md-80">
            How we’re affecting the startup ecosystem
          </h2>
          <p class="fs18 lh18 pt-30" v-html="sections[1]"></p>
          <h2 class="pt-60 pt-md-80">
            How we got here
          </h2>
          <p class="fs18 lh18" v-html="sections[2]"></p>
          <br />
          <p class="fs18 lh18" v-html="sections[3]"></p>
        </b-col>
      </b-row>
      <b-row align-v="center" class="py-60 py-md-140">
        <b-col xl="6" class="text-center">
          <picture class="img-fluid">
            <source
              srcset="
                ~/assets/components/page-about/img1.jpg    1x,
                ~/assets/components/page-about/img1@2x.jpg 2x
              "
            />
            <img
              class="img-fluid"
              src="~/assets/components/page-about/img1.jpg"
              alt="person with headphones on brainstorming"
            />
          </picture>
        </b-col>
        <b-col class="text-center mt-40 mt-xl-0 pb-80">
          <picture class="img-fluid">
            <source
              srcset="
                ~/assets/components/page-about/img2.jpg    1x,
                ~/assets/components/page-about/img2@2x.jpg 2x
              "
            />
            <img
              class="img-fluid"
              src="~/assets/components/page-about/img2.jpg"
              alt="two people in a meeting and trendy surroundings"
            />
          </picture>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import PageAboutHero from '@/components/page-about/PageAboutHero'
import { buildMetaHead } from '@/helpers/meta'

export default {
  name: 'PageAbout',
  components: {
    PageAboutHero
  },
  head() {
    return buildMetaHead({
      title: 'About The Hub | Connecting talents with Nordic startups',
      description:
        'The Hub is the #1 recruitment platform for Nordic startups, offering career opportunities for global talent. ',
      path: this.$route.path,
      imageUrl: process.env.BASE_URL + '/images/thehub_2022_about.jpg'
    })
  },
  computed: {
    sections() {
      return [
        'Over the last few decades, tech startups have achieved unbelievable things, changing the lives of everyone involved as well as millions of people across the globe in the process. At The Hub, we think startups are one of the greatest forms of giving people true meaning in their lives while making the world a better place. We see a world where people get to work on things that they are passionate about while solving real and challenging problems. Our mission is to help people find truly meaningful work where they can have an impact and take part in building something new from the ground up.',
        'With less than 30 million inhabitants, the Nordic region still operates one of the most dynamic and successful startup ecosystems on the globe with the world’s second highest amount of unicorns per capita, second to Silicon Valley. With startups and scale-ups bursting out of the region at record high rates, the need for exceptional and versatile talent is inevitable. That’s where we come in. Since 2015, more than 1.2 million applications have been submitted to over 14,000 growth companies through The Hub, securing key hires for pre-seed and post-IPO startups, and everything in between. With 120,000+ monthly active users, The Hub is the 2nd largest pure startup recruitment platform in the world. Every month we surface thousands of startup and scale-up jobs from all over the Nordic region.',
        'The Hub was initially started in 2015 by Danske Bank Growth in an attempt to create valuable and impactful services for the rapidly growing Nordic startup ecosystem, focusing on tailored recruitment and fundraising services. They teamed up with Rainmaking to build and operate the service and together they successfully matched 1 million talents with job opportunities and grew the user base to more than 10.000 startups and 300.000 candidates. In 2022, Mesh Community acquired The Hub. They already owned and operated the second largest recruiting platform for startup-ready talent in the Nordics, Startupmatcher, and the two services where merged to create the undisputed market leader for startup recruitment in the Nordics.',
        'With new owners and a strengthened position, The Hub’s focus going forward is to create a complete Nordic recruitment marketplace with a free basic layer for companies that are just starting out, and advanced paid services for growth startups and scale-ups. Empowered by a deep desire to create new and better ways for people to find meaningful work, we invite you to join our journey to become the world’s best startup job board.'
      ]
    }
  }
}
</script>

<style lang="scss">
.view-about {
  p a {
    color: $blue-900;
  }

  .img-maria {
    width: rem(500px);
    height: auto;
    max-width: 75%;
  }
}
</style>
